import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResumeOriginalContentFieldsFragment = { __typename?: 'JobSeekerProfileResume', id: string, resumeType?: Types.JobSeekerProfileResumeType | null, summary?: string | null, skills: Array<{ __typename?: 'JobSeekerProfileSkill', id: string, text?: string | null }>, workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, title?: string | null, company?: string | null, description?: string | null, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, location?: { __typename?: 'JobSeekerProfileLocationType', formattedLocation?: string | null, city?: string | null, admin1?: string | null, unknownLocation?: string | null } | null }> };

export type ResumeOriginalContentEducationFieldsFragment = { __typename?: 'JobSeekerProfileResume', educations: Array<{ __typename?: 'JobSeekerProfileEducation', id: string, school?: string | null, additionalDetails?: string | null, degree: Array<{ __typename?: 'JobSeekerProfileDegree', id: string, degreeName?: string | null, field?: string | null, taxonomyConceptDegree?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null, taxonomyConceptField?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null }>, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, location?: { __typename?: 'JobSeekerProfileLocationType', formattedLocation?: string | null, country?: string | null } | null }> };

export type ResumeOriginalContentCertificationFieldsFragment = { __typename?: 'JobSeekerProfileResume', certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null, description?: string | null, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, taxonomyConceptTitle?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null }> };

export type ResumeOriginalContentQueryVariables = Types.Exact<{
  includeEducations?: Types.Scalars['Boolean']['input'];
  includeCertifications?: Types.Scalars['Boolean']['input'];
}>;


export type ResumeOriginalContentQuery = { __typename?: 'Query', jobSeekerProfile?: { __typename?: 'JobSeekerProfilePayload', profile?: { __typename?: 'JobSeekerProfile', accountKey?: string | null, resume: Array<{ __typename?: 'JobSeekerProfileResume', id: string, resumeType?: Types.JobSeekerProfileResumeType | null, summary?: string | null, skills: Array<{ __typename?: 'JobSeekerProfileSkill', id: string, text?: string | null }>, workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, title?: string | null, company?: string | null, description?: string | null, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, location?: { __typename?: 'JobSeekerProfileLocationType', formattedLocation?: string | null, city?: string | null, admin1?: string | null, unknownLocation?: string | null } | null }>, educations: Array<{ __typename?: 'JobSeekerProfileEducation', id: string, school?: string | null, additionalDetails?: string | null, degree: Array<{ __typename?: 'JobSeekerProfileDegree', id: string, degreeName?: string | null, field?: string | null, taxonomyConceptDegree?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null, taxonomyConceptField?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null }>, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, location?: { __typename?: 'JobSeekerProfileLocationType', formattedLocation?: string | null, country?: string | null } | null }>, certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null, description?: string | null, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, taxonomyConceptTitle?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null }> }> } | null } | null };

export type ResumeOriginalContentDualQueryVariables = Types.Exact<{
  includeEducations?: Types.Scalars['Boolean']['input'];
  includeCertifications?: Types.Scalars['Boolean']['input'];
}>;


export type ResumeOriginalContentDualQuery = { __typename?: 'Query', jobSeekerProfile?: { __typename?: 'JobSeekerProfilePayload', profile?: { __typename?: 'JobSeekerProfile', accountKey?: string | null } | null } | null, jobSeekerResumes?: { __typename?: 'JobSeekerResumesPayload', resumes: Array<{ __typename?: 'JobSeekerResumeBundle', resume?: { __typename?: 'JobSeekerProfileResume', id: string, resumeType?: Types.JobSeekerProfileResumeType | null, summary?: string | null, skills: Array<{ __typename?: 'JobSeekerProfileSkill', id: string, text?: string | null }>, workExperiences: Array<{ __typename?: 'JobSeekerProfileWorkExperience', id: string, title?: string | null, company?: string | null, description?: string | null, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, location?: { __typename?: 'JobSeekerProfileLocationType', formattedLocation?: string | null, city?: string | null, admin1?: string | null, unknownLocation?: string | null } | null }>, educations: Array<{ __typename?: 'JobSeekerProfileEducation', id: string, school?: string | null, additionalDetails?: string | null, degree: Array<{ __typename?: 'JobSeekerProfileDegree', id: string, degreeName?: string | null, field?: string | null, taxonomyConceptDegree?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null, taxonomyConceptField?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null }>, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, location?: { __typename?: 'JobSeekerProfileLocationType', formattedLocation?: string | null, country?: string | null } | null }>, certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null, description?: string | null, dateRange?: { __typename?: 'JobSeekerProfileDateRange', isCurrent?: boolean | null, fromDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null, toDate?: { __typename?: 'JobSeekerProfileDateType', month?: Types.JobSeekerProfileMonthType | null, year?: number | null } | null } | null, taxonomyConceptTitle?: { __typename?: 'JobSeekerProfileTaxonomyConcept', suid?: string | null } | null }> } | null }> } | null };

export const ResumeOriginalContentFieldsFragmentDoc = gql`
    fragment ResumeOriginalContentFields on JobSeekerProfileResume {
  id
  resumeType
  summary
  skills {
    id
    text
  }
  workExperiences {
    id
    title
    company
    description
    dateRange {
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
      isCurrent
    }
    location {
      formattedLocation
      city
      admin1
      unknownLocation
    }
  }
}
    `;
export const ResumeOriginalContentEducationFieldsFragmentDoc = gql`
    fragment ResumeOriginalContentEducationFields on JobSeekerProfileResume {
  educations {
    id
    school
    additionalDetails
    degree {
      id
      degreeName
      field
      taxonomyConceptDegree {
        suid
      }
      taxonomyConceptField {
        suid
      }
    }
    dateRange {
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
      isCurrent
    }
    location {
      formattedLocation
      country
    }
  }
}
    `;
export const ResumeOriginalContentCertificationFieldsFragmentDoc = gql`
    fragment ResumeOriginalContentCertificationFields on JobSeekerProfileResume {
  certifications {
    id
    title
    description
    dateRange {
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
      isCurrent
    }
    taxonomyConceptTitle {
      suid
    }
  }
}
    `;
export const ResumeOriginalContentDocument = gql`
    query ResumeOriginalContent($includeEducations: Boolean! = false, $includeCertifications: Boolean! = false) {
  jobSeekerProfile {
    profile {
      accountKey
      resume {
        ...ResumeOriginalContentFields
        ...ResumeOriginalContentEducationFields @include(if: $includeEducations)
        ...ResumeOriginalContentCertificationFields @include(if: $includeCertifications)
      }
    }
  }
}
    ${ResumeOriginalContentFieldsFragmentDoc}
${ResumeOriginalContentEducationFieldsFragmentDoc}
${ResumeOriginalContentCertificationFieldsFragmentDoc}`;

/**
 * __useResumeOriginalContentQuery__
 *
 * To run a query within a React component, call `useResumeOriginalContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumeOriginalContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumeOriginalContentQuery({
 *   variables: {
 *      includeEducations: // value for 'includeEducations'
 *      includeCertifications: // value for 'includeCertifications'
 *   },
 * });
 */
export function useResumeOriginalContentQuery(baseOptions?: Apollo.QueryHookOptions<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>(ResumeOriginalContentDocument, options);
      }
export function useResumeOriginalContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>(ResumeOriginalContentDocument, options);
        }
export function useResumeOriginalContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>(ResumeOriginalContentDocument, options);
        }
export type ResumeOriginalContentQueryHookResult = ReturnType<typeof useResumeOriginalContentQuery>;
export type ResumeOriginalContentLazyQueryHookResult = ReturnType<typeof useResumeOriginalContentLazyQuery>;
export type ResumeOriginalContentSuspenseQueryHookResult = ReturnType<typeof useResumeOriginalContentSuspenseQuery>;
export type ResumeOriginalContentQueryResult = Apollo.QueryResult<ResumeOriginalContentQuery, ResumeOriginalContentQueryVariables>;
export const ResumeOriginalContentDualDocument = gql`
    query ResumeOriginalContentDual($includeEducations: Boolean! = false, $includeCertifications: Boolean! = false) {
  jobSeekerProfile {
    profile {
      accountKey
    }
  }
  jobSeekerResumes {
    resumes {
      resume {
        ...ResumeOriginalContentFields
        ...ResumeOriginalContentEducationFields @include(if: $includeEducations)
        ...ResumeOriginalContentCertificationFields @include(if: $includeCertifications)
      }
    }
  }
}
    ${ResumeOriginalContentFieldsFragmentDoc}
${ResumeOriginalContentEducationFieldsFragmentDoc}
${ResumeOriginalContentCertificationFieldsFragmentDoc}`;

/**
 * __useResumeOriginalContentDualQuery__
 *
 * To run a query within a React component, call `useResumeOriginalContentDualQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumeOriginalContentDualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumeOriginalContentDualQuery({
 *   variables: {
 *      includeEducations: // value for 'includeEducations'
 *      includeCertifications: // value for 'includeCertifications'
 *   },
 * });
 */
export function useResumeOriginalContentDualQuery(baseOptions?: Apollo.QueryHookOptions<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>(ResumeOriginalContentDualDocument, options);
      }
export function useResumeOriginalContentDualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>(ResumeOriginalContentDualDocument, options);
        }
export function useResumeOriginalContentDualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>(ResumeOriginalContentDualDocument, options);
        }
export type ResumeOriginalContentDualQueryHookResult = ReturnType<typeof useResumeOriginalContentDualQuery>;
export type ResumeOriginalContentDualLazyQueryHookResult = ReturnType<typeof useResumeOriginalContentDualLazyQuery>;
export type ResumeOriginalContentDualSuspenseQueryHookResult = ReturnType<typeof useResumeOriginalContentDualSuspenseQuery>;
export type ResumeOriginalContentDualQueryResult = Apollo.QueryResult<ResumeOriginalContentDualQuery, ResumeOriginalContentDualQueryVariables>;